module.exports = __webpack_public_path__ + "img/position-elevator.d042f610.png";